/* tslint:disable */

/* ********************************************************
 * THIS FILE IS AUTO GENERATED BY A TOOL - DO NOT CHANGE IT
 * RUN npm run openapi-client-gen TO REGENERATE THE FILE
 * *******************************************************/

import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
class ResourcerService extends __BaseService {
static readonly getTeksterPath = '/resourcer/tekster';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param version undefined
   * @return Success
   */
  private getTeksterResponse(version?: string): __Observable<__StrictHttpResponse<{[key: string]: string}>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (version != null) __params = __params.set('version', version.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/resourcer/tekster`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{[key: string]: string}>;
      })
    );
  }

  /**
   * @param version undefined
   * @return Success
   */
  getTekster(version?: string): __Observable<{[key: string]: string}> {
    return this.getTeksterResponse(version).pipe(
      __map(_r => _r.body as {[key: string]: string})
    );
  }
}

module ResourcerService {
}

export { ResourcerService }
